import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'etcho.privateMode';

/**
 * Replaces the old server-side `privateModeCookie` + route action. Private mode
 * is a pure UI preference, so it lives in localStorage now.
 */
export function usePrivateMode(): {
    isPrivateMode: boolean;
    togglePrivateMode: () => void;
} {
    const [isPrivateMode, setIsPrivateMode] = useState<boolean>(() => {
        if (typeof window === 'undefined') return false;
        return window.localStorage.getItem(STORAGE_KEY) === 'true';
    });

    useEffect(() => {
        window.localStorage.setItem(STORAGE_KEY, String(isPrivateMode));
    }, [isPrivateMode]);

    const togglePrivateMode = useCallback(
        () => setIsPrivateMode((prev) => !prev),
        []
    );

    return { isPrivateMode, togglePrivateMode };
}
